// AI探索境界: docs/design/foundation/responsibility/shopify-theme-boundary-map.md
function copyURI(evt) {
	evt.preventDefault();
	navigator.clipboard.writeText(window.location.href);
}

const copyLinks = document.querySelectorAll('.copy-btn');

for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI)
}
